import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const PenIcon = ({ stroke, height, width }: { stroke?: string; width?: any; height?: string }) => {
	return (
		<Icon
			width={width || '12px'}
			height={height || '12px'}
			viewBox="0 0 12 12"
			fill="none"
		>
			<path
				d="M8.82139 0.959577C8.96709 0.813873 9.14007 0.698295 9.33044 0.61944C9.52081 0.540586 9.72485 0.5 9.9309 0.5C10.137 0.5 10.341 0.540586 10.5314 0.61944C10.7217 0.698295 10.8947 0.813873 11.0404 0.959577C11.1861 1.10528 11.3017 1.27826 11.3806 1.46863C11.4594 1.659 11.5 1.86304 11.5 2.0691C11.5 2.27515 11.4594 2.47919 11.3806 2.66956C11.3017 2.85993 11.1861 3.03291 11.0404 3.17861L3.55117 10.6679L0.5 11.5L1.33214 8.44883L8.82139 0.959577Z"
				stroke={stroke || 'white'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
